<div class="dashboard">
  <!-- KPI Cards -->
  <div class="stats">
    <div *ngFor="let stat of stats" class="card" [ngClass]="stat.type">
      <div class="title">{{ stat.title }}</div>
      <div class="value">{{ stat.value }}</div>
      <div class="change">{{ stat.change }}</div>
    </div>
  </div>

  <!-- Charts -->
  <div class="charts">
    <div class="chart">📊 Tickets by Status (Chart Here)</div>
    <div class="chart">📈 Tickets by Priority (Chart Here)</div>
  </div>

  <!-- Table -->
  <div class="table-container">
    <h2>Recent Tickets</h2>
    <table>
      <thead>
        <tr>
          <th>ID</th>
          <th>Subject</th>
          <th>Stage</th>
          <th>Status</th>
          <th>Assigned To</th>
          <th>Created</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let t of tickets">
          <td>{{ t.id }}</td>
          <td>{{ t.subject }}</td>
          <td>{{ t.stage }}</td>
          <td>
            <span class="badge" [ngClass]="t.status.toLowerCase()">
              {{ t.status }}
            </span>
          </td>
          <td>{{ t.assignedTo }}</td>
          <td>{{ t.created }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
